<div class="scores-container">
  <table>
    <tr class="header">
      <th style="width: '10%'">S.No</th>
      <th style="width: '25%'">Course Name</th>
      <th style="width: '15%'">Average</th>
      <th style="width: '30%'">Details</th>
      <th style="width: '30%'">Certificate</th>
    </tr>
    <tr class="body" *ngFor="let course of courseNames; let i=index">
      <td style="width: '10%'">{{i+1}}</td>
      <td style="width: '25%'">{{course['name']}}</td>
      <td style="width: '15%'">{{getAverage(scores[course['name']])}}%</td>
      <td class="scores" style="width: '30%'">
        <div class="score" *ngFor="let mark of scores[course]">{{mark}}%</div>
      </td>
      <td style="width: '30%'">
        <div class="certificate-icon" [ngClass]="{'disableCertificate': !course.isComplete}" (click)="onClickCertificate(course)">
          <i class="fa-solid fa-file-arrow-down"></i>
        </div>      
      </td>
    </tr>
  </table>
</div>